import React, { useState } from "react";
import { Link } from "react-router-dom";
import { 
  Accordion, 
  AccordionSummary, 
  AccordionDetails, 
  Typography, 
  Card, 
  CardContent, 
  CardActions, 
  Button,
  Box 
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const HomePage = () => {
    // State to control expansion of the sections
    const [expanded, setExpanded] = useState('registered');

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    // 6-week curriculum data for Deep Foundry - @Learn
    const registeredCourses = [
        { week: "Deep Foundry - @Learn: Session 1", title: "The History of Modern Information Technology", description: "From the Abacus, through Transistors to Quantum Computing." },
        { week: "Deep Foundry - @Learn: Session 2", title: "Systems, Platforms, Frameworks & Architecture", description: "The 4 Pillars of Modern Information Technology." },
        { week: "Deep Foundry - @Learn: Session 3", title: "Data Science & The Economic Value of Data", description: "Turning Infrastructure and Data into Economic Value." },
        { week: "Deep Foundry - @Learn: Session 4", title: "From Data Science to Artificial Intelligence", description: "Understanding the Technology Transforming Business." },
        { week: "Deep Foundry - @Learn: Session 5", title: "Quantum, Edge, AI and the Future", description: "The Future State of Technology Convergence." },
        { week: "Deep Foundry - @Learn: Session 6", title: "Capstone, Recap & Whats Next", description: "Synthesizing Learnings into a Personal or Organizational Roadmap." }
    ];

    return (
        <>
            <div className="container-fluid py-4">
                <div className="container">
                    {/* Header Section */}
                    <div className="row mb-4">
                        <div className="col-md">
                            <Typography variant="h4" component="h1" gutterBottom fontWeight="bold">
                                Learning Center
                            </Typography>
                        </div>
                    </div>

                    {/* Collapsible Section 1: Registered Courses */}
                    <Accordion 
                        expanded={expanded === 'registered'} 
                        onChange={handleChange('registered')}
                        sx={{ mb: 2, boxShadow: 2, borderRadius: '8px !important', '&:before': { display: 'none' } }}
                    >
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="registered-content"
                            id="registered-header"
                        >
                            <Typography variant="h6" fontWeight="600">Registered Courses</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            {/* Strict CSS Grid Container guaranteeing uniform columns and rows */}
                            <Box 
                                sx={{ 
                                    display: 'grid', 
                                    gridTemplateColumns: { 
                                        xs: '1fr',            // 1 column on mobile
                                        sm: 'repeat(2, 1fr)', // 2 columns on tablets
                                        md: 'repeat(3, 1fr)'  // Exactly 3 equal columns on desktop
                                    }, 
                                    gap: 3,
                                    alignItems: 'stretch'
                                }}
                            >
                                {registeredCourses.map((item) => (
                                    <Card 
                                        key={item.week}
                                        variant="outlined" 
                                        sx={{ 
                                            display: 'flex', 
                                            flexDirection: 'column', 
                                            justifyContent: 'space-between', 
                                            borderRadius: 2,
                                            height: '100%',
                                            minHeight: '230px' // Ensures balanced vertical baseline across all cards
                                        }}
                                    >
                                        <CardContent>
                                            <Typography color="primary" gutterBottom variant="overline" fontWeight="bold">
                                                Module {item.week}
                                            </Typography>
                                            <Typography variant="h6" component="div" gutterBottom sx={{ fontSize: '1.05rem', lineHeight: 1.35 }}>
                                                {item.title}
                                            </Typography>
                                            <Typography variant="body2" color="text.secondary">
                                                {item.description}
                                            </Typography>
                                        </CardContent>
                                        <CardActions sx={{ p: 2, pt: 0 }}>
                                            <Button 
                                                component={Link} 
                                                to={`/course-player/week-${item.week}`} 
                                                size="small" 
                                                variant="contained" 
                                                fullWidth
                                            >
                                                Access Module
                                            </Button>
                                        </CardActions>
                                    </Card>
                                ))}
                            </Box>
                        </AccordionDetails>
                    </Accordion>

                    {/* Collapsible Section 2: Active Courses */}
                    <Accordion 
                        expanded={expanded === 'active'} 
                        onChange={handleChange('active')}
                        sx={{ mb: 2, boxShadow: 2, borderRadius: '8px !important', '&:before': { display: 'none' } }}
                    >
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="active-content"
                            id="active-header"
                        >
                            <Typography variant="h6" fontWeight="600">Pending Courses</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Typography variant="body2" color="text.secondary">
                                No active courses or modules at this time.
                            </Typography>
                        </AccordionDetails>
                    </Accordion>

                    {/* Collapsible Section 3: Completed Courses */}
                    <Accordion 
                        expanded={expanded === 'completed'} 
                        onChange={handleChange('completed')}
                        sx={{ mb: 2, boxShadow: 2, borderRadius: '8px !important', '&:before': { display: 'none' } }}
                    >
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="completed-content"
                            id="completed-header"
                        >
                            <Typography variant="h6" fontWeight="600">Completed Courses</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Typography variant="body2" color="text.secondary">
                                You have not completed any modules yet. Finished modules will appear here automatically upon completion.
                            </Typography>
                        </AccordionDetails>
                    </Accordion>


                </div>
            </div>
        </>
    );
};

export default HomePage;